import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss'],
})
export class ConfirmationBoxComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmationBoxComponent>,
  ) {}
  userRemarks: string = '';
  remarksInvalid: boolean = true;

  isdisabled(): boolean {
    if (this.data.remarksMandatory) {
      return this.userRemarks.trim() === '';
    } else {
      return false;
    }
  }

  myMethod(val: boolean) {
    if (this.data.remarksHeading) {
      this.dialogRef.close({ confirmed: val, remarks: this.userRemarks });
    } else {
      this.dialogRef.close(val);
    }
  }
}
